import { useState, useEffect } from "react"
import { Database } from "../typings"

const databasePath = "/metadata.json"

const useModel = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [database, setDatabase] = useState<Database>(undefined)

  useEffect(() => {
    fetch(databasePath).then(response => {
      response.json().then(json => {
        setDatabase(json)
        setIsLoading(false)
      })
    })
  }, [])

  return {
    isLoading,
    database,
  }
}

export default useModel
